import { Select } from "antd";

/**
 * LF360-2100 phase 2 — how far AI assistants may go, for the organization's
 * and a project's AI connector settings. The server keeps the order
 * (read < drafts < publish) and the cap; this only shows them.
 */

const LABELS = {
  read: "Read: search and read content",
  drafts: "Drafts: also create and edit drafts",
  publish: "Publish: also ask for publishing",
};

const ORDER = ["read", "drafts", "publish"];

export const isWider = (from, to) => ORDER.indexOf(to) > ORDER.indexOf(from);

export const WIDEN_TO_DRAFTS = {
  title: "Let AI assistants write drafts?",
  content:
    "The assistants of Organization and System admins will be able to create and edit drafts of articles, "
    + "FitFacts, tasks, scenarios and plans, each marked as created via AI. Nothing reaches subjects until "
    + "someone publishes it in the portal.",
  okText: "Allow drafts",
};

/**
 * @param phases  what can be chosen (from the server)
 * @param limit   the highest phase allowed here (a project's organization), or none
 */
const PhaseSelect = ({ value, phases = [], limit, loading, disabled, onChange, label }) => (
  <Select
    aria-label={label}
    className="ai-connectors__phase"
    value={value}
    loading={loading}
    disabled={disabled || loading}
    onChange={onChange}
    options={phases.map((phase) => {
      const aboveLimit = Boolean(limit) && ORDER.indexOf(phase) > ORDER.indexOf(limit);
      return {
        value: phase,
        label: aboveLimit ? <span title="Limited by organization policy">{LABELS[phase] || phase}</span> : (LABELS[phase] || phase),
        disabled: aboveLimit,
      };
    })}
  />
);

export default PhaseSelect;
